import { Route, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider, Router } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "./styles.css";
import "./styles/global.css";
import RootLayoutV2 from "./layouts/RootLayoutV2";
import NewSignIn from "./pages/Signin";
import Assets from "./pages/Assets";
import AssetView from "./pages/Assets/tabs/index";
import AlertsPage from "./pages/AlertsPage";
import AlertsDetails from "./pages/AlertsPage/Alerts/AlertsDetails";
import ForgotPassword from "./pages/Signin/forgotpassword";
import BulkDetails from "./pages/AlertsPage/Alerts/BulkDetails";
import Devices from "./pages/Devices";
import BulkDeviceDetails from "./pages/Devices/BulkDeviceDetails";
import ManageDevices from "./pages/Devices/ManageDevices";
import Users from "./pages/User";
import CreateUser from "./pages/User/CreateUser";
import Role from "./pages/Role";
import CreateRole from "./pages/Role/CreateRole";
import Organization from "./pages/Organization";
import CreateOrganization from "./pages/Organization/CreateOrganization";
import LocationDetails from "./pages/LocationDetails";
// import CreateLocation from "./pages/LocationDetails/CreateLocation";
import LocationOptPopup from "./pages/LocationDetails/CreateLocation/LocationOptPopup";
import EditDevice from "./pages/Devices/EditDevice";
import Insights from "./pages/Insights";
//import ViewAssetMap from "./pages/Assets/ViewAssetMap";
//import ViewDeviceMap from "./pages/Assets/ViewDeviceMap";
//import ViewDeviceDashboard from "./pages/Assets/ViewDeviceDashboard";
//import ViewDeviceExplorer from "./pages/Assets/ViewDeviceExplorer";
import ViewDeviceDashboard from "./pages/Devices/Dashboard";
import ViewDeviceExplorer from "./pages/Devices/Explorer";
import ViewDeviceMap from "./pages/Devices/Map";
import Shipments from "./pages/Shipments";

import MyProfile from "./pages/MyProfile";
import Search from "./pages/GlobalSearch";
import { useSelector, useDispatch } from "react-redux";
import { watchLogin, logout, autoLogout } from "./store/actions/auth";
import SetupPassword from "./pages/Signin/setuppassword";
import CreateShipment from "./pages/Shipments/CreateShipments";
import ViewShipment from "./pages/Shipments/CreateShipments/viewshipment";
import DeviceProfile from "./pages/DeviceProfile";
import Support from "./pages/support/new";

import useAutoLogout from "./global/hooks/useAutoLogout";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { IconButton } from "@mui/material";
import CloseIcon from "./assets/close_icon.svg";
import OrgSelector from "./pages/Signin/orgselector";
import ProtectedRoute from "./layouts/ProtectedRoute";

function App() {
  const minutes = 30;
  const inactivityLimit = minutes * 60 * 1000;
  useAutoLogout(inactivityLimit);
  const [activeSession, setActiveSession] = useState({
    username: "",
    access_token: "",
  });
  const [accountId, setAccountId] = useState("");
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isAutoLogoutenabled = useSelector((state) => state.auth.isAutoLogout);

  const autoLogoutTimeout = useRef(null);

  useEffect(() => {
    if (user === null) {
      dispatch(watchLogin());
    }

    window.addEventListener("popstate", handleUse)

    return () => {
      window.removeEventListener("popstate", handleUse)
    }

  }, [user, dispatch]);

  useEffect(() => {
    if (autoLogoutTimeout.current) {
      clearTimeout(autoLogoutTimeout.current);
    }

    if (isAutoLogoutenabled) {
      autoLogoutTimeout.current = setTimeout(() => {
        handleLogout();
      }, 30000);
    }
    return () => {
      if (autoLogoutTimeout.current) {
        clearTimeout(autoLogoutTimeout.current);
      }
    };
  }, [isAutoLogoutenabled]);

  function setSession() {
    let session = sessionStorage.getItem("activeSession");
    if (session) {
      session = JSON.parse(session);
      if (new Date().getTime() > session.expiry) {
        sessionStorage.removeItem("activeSession");
      } else {
        setActiveSession(session);
      }
    }
    return session;
  }

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem('lasActivity');
    dispatch(logout());
  };

  const handleUse = () => {
    dispatch(autoLogout(false));
    if (autoLogoutTimeout.current) {
      clearTimeout(autoLogoutTimeout.current);
    }
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route
          path="/login"
          element={
            <NewSignIn
              setSession={setSession}
              activeSession={activeSession}
              setActiveSession={setActiveSession}
              accountId={accountId}
              setAccountId={setAccountId}
            />
          }
        />

        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="setuppassword" element={<SetupPassword />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<RootLayoutV2 />}>
            <Route path="" element={<NewSignIn />} />

            <Route path="signin" element={<NewSignIn />} />

            {user?.role?.permissions?.assets?.view ? (
              <Route path="assets" element={<Assets />} />
            ) : null}
            <Route path="assets/:id" element={<AssetView />} />
            <Route path="shipments" element={<Shipments />} />
            <Route path="support" element={<Support />} />
            {user?.role?.permissions?.insights?.view ? (
              <Route path="insights" element={<Insights />} />
            ) : null}

            {user?.role?.permissions?.alarms?.view ? (
              <Route path="alerts" element={<AlertsPage />} />
            ) : null}
            {user?.role?.permissions?.alarms?.view ? (
              <Route path="alertdetails" element={<AlertsDetails />} />
            ) : null}
            {user?.role?.permissions?.alarms?.edit ? (
              <Route path="bulkdetails" element={<BulkDetails />} />
            ) : null}

            {user?.role?.permissions?.devices?.edit ? (
              <Route path="edit-device" element={<EditDevice />} />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
              <Route path="devices" element={<Devices />} />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
              <Route path="bulkdevicedetails" element={<BulkDeviceDetails />} />
            ) : null}
            {user?.role?.permissions?.devices?.edit ||
              user?.role?.permissions?.devices?.create ? (
              <Route path="managedevices" element={<ManageDevices />} />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
            <Route path="devices/:id/map" element={<ViewDeviceMap />} />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
              <Route
                path="devices/:id/dashboard"
                element={<ViewDeviceDashboard />}
              />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
              <Route
                path="devices/:id/explorer"
                element={<ViewDeviceExplorer />}
              />
            ) : null}
            {user?.role?.permissions?.devices?.view ? (
              <Route path="device-profile" element={<DeviceProfile />} />
            ) : null}

            {user?.role?.permissions?.users?.view ? (
              <Route path="users" element={<Users />} />
            ) : null}
            {user?.role?.permissions?.users?.create ||
              user?.role?.permissions?.users?.edit ? (
              <Route path="createuser" element={<CreateUser />} />
            ) : null}

            {user?.role?.permissions?.roles?.view ? (
              <Route path="roles" element={<Role />} />
            ) : null}
            {user?.role?.permissions?.roles?.edit ||
              user?.role?.permissions?.roles?.create ? (
              <Route path="createrole" element={<CreateRole />} />
            ) : null}

            {user?.role?.permissions?.organizations?.view ? (
              <Route path="organization" element={<Organization />} />
            ) : null}
            {user?.role?.permissions?.organizations?.edit ||
              user?.role?.permissions?.organizations?.create ? (
              <Route path="createorganization" element={<CreateOrganization />} />
            ) : null}

            {user?.role?.permissions?.Locations?.view ? (
              <Route path="locationdetails" element={<LocationDetails />} />
            ) : null}
            {user?.role?.permissions?.Locations?.edit ||
              user?.role?.permissions?.Locations?.create ? (
              <Route path="createlocation" element={<LocationOptPopup />} />
            ) : null}
            {user?.role?.permissions?.assets?.view ? (
              <Route path="createshipment" element={<CreateShipment />} />
            ) : null}
            <Route path="viewshipment/:id" element={<ViewShipment />} />

            {/* {user?.role?.permissions?.assets?.view ? (
              <Route path="assetmap/:id/map" element={<ViewAssetMap />} />
            ) : null} */}

            <Route path="search" element={<Search />} />
            <Route path="profile" element={<MyProfile />} />
          </Route>
          <Route path="*" element={<Navigate to={"/login"} />} />
        </ Route>
      </ Route>
    )
  );

  return (
    <>
      <RouterProvider router={router} />
      {user && (
        <Modal
          surface="light"
          fullScreenDialog={false}
          disableAnimation={false}
          disableOutsideClick={false}
          ariaLabel="Session Modal"
          opened={isAutoLogoutenabled}
          width="800px"
          closeButton={<div style={{ position: 'relative' }}>
            <IconButton style={{ position: "absolute", top: -38, right: 8 }} onClick={handleUse}>
              <img alt="close button" src={CloseIcon} height={"15px"} width={"15px"} />
            </IconButton>
          </div>
          }
        >
          <ModalTitle><span className="font-face-vzw">Session Expired</span></ModalTitle>
          <ModalBody>
            <span style={{ fontWeight: 400, fontSize: "16px" }}>
              You will be logged out soon. For your security, we log you out
              automatically when you have not been active for a certain period of
              time.
            </span>
          </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                width: "100%",
                children: <span className="font-face-vzw" style={{ color: '#fff' }}>Log out now</span>, // style={{color: '#fff'}} is because sometime this modal primary button become black background
                onClick: handleLogout,
              },
              close: {
                width: "100%",
                children: "Continue session",
                onClick: handleUse,
              },
            }}
          />
        </Modal>
      )}
      <OrgSelector />
    </>
  );
}

export default App;
